/**
 * Frontend-only visibility gate for the Sales Sequences (cadence) feature.
 *
 * IMPORTANT: this is NOT a security boundary. It only hides the Sequences
 * nav link, detail-modal tab, row action, /sequences + /today pages, and the
 * Slack morning brief from users who aren't part of the in-progress rollout —
 * so the UI isn't confusing for the rest of the team while we build it out.
 * The underlying tables, RLS, and APIs are not feature-gated here.
 *
 * To launch to everyone later: delete this file and its call sites (search for
 * `canUseSequences` / `useSequencesAccess` / `SEQUENCES_ALLOWED_EMAILS`).
 */
export const SEQUENCES_ALLOWED_EMAILS = [
  "miclainkeffeler@westtn.consulting",
  "miclain.keffeler@westtn.consulting",
] as const;

/** True only for the hardcoded rollout allowlist. Email match is case-insensitive. */
export function canUseSequences(email: string | null | undefined): boolean {
  if (!email) return false;
  const normalized = email.trim().toLowerCase();
  return SEQUENCES_ALLOWED_EMAILS.some((allowed) => allowed === normalized);
}
